var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 20,
    viewBox: "0 0 184 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vita Student Logo",
    clipPath: "url(#clip0_170_5178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 84",
    d: "M13.8648 1.1944L8.61042 12.9859L3.36124 1.1944H0L8.56118 19.4907H8.65966L17.1949 1.1944H13.8648ZM20.7324 19.2212H23.7982V1.1944H20.7324V19.2212ZM27.4212 1.1944V3.91553H33.5295V19.2212H36.5953V3.91553H42.7023V1.1944H27.4212ZM49.9586 7.17699L52.6797 13.4317H47.2375L49.9586 7.17699ZM49.9093 0.873047L41.422 19.2212H44.7586L46.184 15.9585H53.7358L55.1611 19.2212H58.4977L50.0065 0.873047H49.9093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 85",
    d: "M78.1883 2.76147L76.5686 5.28823C75.3159 4.22617 73.7222 3.65154 72.08 3.6698C70.2893 3.6698 69.0881 4.43042 69.0881 6.07346C69.0881 7.42237 69.9459 7.98603 72.8458 8.57561C77.359 9.53189 78.9049 11.1257 78.9049 13.8974C78.9049 17.2586 76.3781 19.5145 72.3068 19.5145C69.8367 19.5928 67.425 18.7541 65.5364 17.1601L67.204 14.6087C68.6077 15.942 70.4681 16.6879 72.404 16.6936C74.4889 16.6936 75.8378 15.8112 75.8378 14.1669C75.8378 12.8426 74.8323 12.1312 71.9621 11.5429C67.4489 10.562 66.0016 8.89307 66.0016 6.21989C66.0003 3.03228 68.426 0.848902 72.1047 0.848902C74.2887 0.793209 76.4291 1.4661 78.1883 2.76147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 86",
    d: "M96.0919 3.89015H89.9849V19.1958H86.9178V3.89015H80.8108V1.16772H96.0919V3.89015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 87",
    d: "M112.783 12.7947C112.783 16.8427 110.451 19.5159 106.013 19.5159C101.549 19.5159 99.219 16.8427 99.219 12.7947V1.16772H102.285V12.6029C102.285 15.0558 103.535 16.6989 106.013 16.6989C108.466 16.6989 109.717 15.0558 109.717 12.6029V1.16772H112.783V12.7947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 88",
    d: "M122.571 1.16772H116.999V19.1971H122.571C128.752 19.1971 132.333 15.8605 132.333 10.1708C132.333 4.48102 128.697 1.16772 122.571 1.16772ZM122.497 16.3762H120.069V4.01325H122.497C126.862 4.01325 129.243 6.27048 129.243 10.1695C129.243 14.0944 126.888 16.3749 122.497 16.3749",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 89",
    d: "M147.165 3.98863H138.85V8.72209H146.106V11.3966H138.85V16.3762H147.361V19.1971H135.783V1.16772H147.164L147.165 3.98863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 90",
    d: "M165.467 19.5145H165.375L154.385 8.01062V19.1958H151.319V0.848877H151.418L162.406 12.3281V1.16764H165.472L165.467 19.5145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 91",
    d: "M184.04 3.89015H177.933V19.1958H174.873V3.89015H168.764V1.16772H184.045L184.04 3.89015Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170_5178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.ffe3babe1d23e710d4ea1d4b2d379c80.svg";
export { ForwardRef as ReactComponent };